(function ($) {

    /**
     * @var Datatable
     */
    let dt;

    /**
     * Constructor
     *
     * @param options
     * @constructor
     */
    function Alerts(options) {
        console.log('Alerts initialization');

        if (!options) {
            throw new Error('No options passed to Alerts constructor');
        }

        this.options = $.extend({}, Alerts.defaults, options);
        this.setup();
    }

    /**
     * Prepare instance
     */
    Alerts.prototype.setup = function () {
        let self = this;
        this.setupDatatable();

        let body = $('body');

        body.on('click', '#create-alert', function (event) {
            event.preventDefault;
            $('#alerts-modal').data('alert-id', '');
            $('#create-alert-title').show();
            $('#update-alert-title').hide();
            self.resetModalForm();
        })

        body.on('click', '#update-alert', function (event) {
            event.preventDefault;
            $('#create-alert-title').hide();
            $('#update-alert-title').show();
            self.updateAlert($(event.target));
        });

        body.on('click', '#delete-alert', function (event) {
            event.preventDefault;
            self.deleteAlert($(event.target));
        });

        $('#alerts-modal-form').on('submit', function (event) {
            event.preventDefault();
            self.submitForm();
        });

        $('#alerts-modal').on('hide.bs.modal', function (e) {
            console.log('Show modal');
        });
        this.addNumberFields();
    }

    Alerts.prototype.addNumberFields = function () {
        new NumberInput({});
    }

    /**
     * Setup Datatable
     */
    Alerts.prototype.setupDatatable = function () {
        dt = $('#alerts-table').DataTable({
            searching: false,
            lengthChange: false,
            "autoWidth": false,
            responsive: {
                details: true
            },
            "columnDefs": [
                {
                    orderable: false,
                    targets: -1
                }
            ],
            "language": {
                "emptyTable": "No alerts have been set"
            }

        });
    }

    /**
     * Reset modal form
     */
    Alerts.prototype.resetModalForm = function () {
        $('#alerts-modal-form').trigger("reset");
        let modalContent = $('#modal-content');
        let modalMessage = $('#modal-message');
        modalContent.show();
        modalMessage.empty().hide();
    }

    /**
     * Update Alert
     *
     * @param obj
     */
    Alerts.prototype.updateAlert = function (obj) {
        this.resetModalForm();

        let modalForm = $('#alerts-modal-form');
        let row = $(obj.closest('tr'));

        let industry;
        if (row.data('industries').length) {
            industry = row.data('industries')[0];
        } else {
            industry = 'any_industry';
        }

        console.log(industry);

        let region;
        if (row.data('regions').length) {
            region = row.data('regions')[0];
        } else {
            region = 'any_region';
        }

        console.log(region);

        $('#alerts-modal').data('alert-id', row.data('alert-id'));

        modalForm.find('[name="frequency"]').val(row.data('frequency'));
        modalForm.find('[name="frequency-time"]').val(row.data('frequency-time'));
        modalForm.find('[name="industry"]').val(industry);
        modalForm.find('[name="region"]').val(region);
        modalForm.find('[name="revenue_min"]').val(row.data('revenue-min'));
        modalForm.find('[name="revenue_max"]').val(row.data('revenue-max'));
        modalForm.find('[name="adjusted_ebitda_min"]').val(row.data('adjusted-ebitda-min'));
        modalForm.find('[name="adjusted_ebitda_max"]').val(row.data('adjusted-ebitda-max'));
    }

    /**
     * Remove alert
     *
     * @param obj
     */
    Alerts.prototype.deleteAlert = function (obj) {
        let data = {
            action: 'delete',
            data: {
                alertID: obj.closest('tr').data('alert-id')
            }
        }
        this.sendRequest(this, data);
    }

    /**
     * Submit form
     */
    Alerts.prototype.submitForm = function () {
        let modalForm = $('#alerts-modal-form');
        let data = {};

        data.data = {
            frequency: modalForm.find('[name="frequency"] option:selected').val(),
            frequency_time: modalForm.find('[name="frequency-time"] option:selected').val(),
            industry: modalForm.find('[name="industry"] option:selected').val(),
            region: modalForm.find('[name="region"] option:selected').val(),
            revenue_min: modalForm.find('[name="revenue_min"]').val(),
            revenue_max: modalForm.find('[name="revenue_max"]').val(),
            adjusted_ebitda_min: modalForm.find('[name="adjusted_ebitda_min"]').val(),
            adjusted_ebitda_max: modalForm.find('[name="adjusted_ebitda_max"]').val(),
        };

        let alertID = $('#alerts-modal').data('alert-id');

        if (alertID) {
            data.action = 'update';
            data.data.alertID = alertID;
        } else {
            data.action = 'add';
        }

        this.sendRequest(this, data);
    }

    /**
     * Send request
     */
    Alerts.prototype.sendRequest = function (self, data) {
        self.validateData(data);
        jQuery.ajax({
            type: 'POST',
            url: self.options.apiRoute,
            data: data,
            dataType: "json",
            beforeSend: function (xhr) {
                self.disableInputs();
                xhr.setRequestHeader('X-WP-Nonce', self.options.nonce);
            },
            complete: function (xhr) {
                self.enableInputs();
            },
            success: function (response) {
                self.parseResponse(response, self);
            },
            error: function (data) {
                console.log(data);
            }
        });
    }

    /**
     * Disable all modal form inputs
     */
    Alerts.prototype.disableInputs = function () {
        let modalForm = $("#alerts-modal-form");
        modalForm.find("input").prop("disabled", true);
        modalForm.find('select').prop("disabled", true);
    }

    /**
     * Enable all modal inputs
     */
    Alerts.prototype.enableInputs = function () {
        let modalForm = $("#alerts-modal-form");
        modalForm.find("input").prop("disabled", false);
        modalForm.find('select').prop("disabled", false);
    }

    /**
     * Validate data before send request
     *
     * @param data
     */
    Alerts.prototype.validateData = function (data) {
        if (typeof data.action === 'undefined') {
            throw new Error('Request action not found');
        }

        if ((data.action === 'update' || data.action === 'delete') && typeof data.data.alertID === 'undefined') {
            throw new Error('Required action ID');
        }
    }

    /**
     * Parse request
     *
     * @param response
     */
    Alerts.prototype.parseResponse = function (response) {
        console.log(response);
        if (!response.status) {
            console.log('Response error');
            return;
        }
        this.resetModalForm();
        let modalContent = $('#modal-content');
        let modalMessage = $('#modal-message');

        switch (response.action) {
            case 'add':
                modalContent.hide();
                modalMessage.empty().append('Your alert has been created').show();
                this.addRow(response.data);
                break;
            case 'update':
                modalContent.hide();
                modalMessage.empty().append('Your alert has been updated').show();
                this.updateRow(response.data);
                break;
            case 'delete':
                dt.row($('tr[data-alert-id="' + response.data.alertID + '"]')).remove().draw();
                break;
        }
    }

    /**
     * Add new row to the table
     *
     * @param data
     */
    Alerts.prototype.addRow = function (data) {
        let max = 0;
        console.log(dt.column(0).data());
        if (!$('#alerts-table .dataTables_empty').length) {
            max = dt.column(0).data().reduce(function (a, b) {
                return Math.max(a, b);
            });
        }

        let row = dt.row.add([
            max + 1,
            data.frequency_label,
            data.industries_links,
            '£' + data.revenue_min + 'm - £' + data.revenue_max + 'm',
            '£' + data.adjusted_ebitda_min + 'm - £' + data.adjusted_ebitda_max + 'm',
            data.regions_links,
            data.buttons
        ]).draw().node();
        $(row).attr('data-alert-id', data.alert_id);

        this.changeRow(data);
    }

    /**
     * Update existing row on the table
     *
     * @param data
     */
    Alerts.prototype.updateRow = function (data) {
        let row = dt.row('[data-alert-id="' + data.alertID + '"]');

        row.data([
            row.data()[0],
            data.frequency_label,
            data.industries_links,
            '£' + data.revenue_min + 'm - £' + data.revenue_max + 'm',
            '£' + data.adjusted_ebitda_min + 'm - £' + data.adjusted_ebitda_max + 'm',
            data.regions_links,
            data.buttons
        ]).draw();

        this.changeRow(data);
    }

    /**
     * Add data to row
     *
     * @param data
     */
    Alerts.prototype.changeRow = function (data) {
        let row = $('tr[data-alert-id="' + data.alert_id + '"]');

        row.data('alert-id', data.alert_id);
        row.data('frequency', data.frequency);
        row.data('frequency-time', data.frequency_time);
        row.data('regions', data.regions_ids);
        row.data('industries', data.industries_ids);
        row.data('revenue-min', data.revenue_min);
        row.data('revenue-max', data.revenue_max);
        row.data('adjusted-ebitda-min', data.adjusted_ebitda_min);
        row.data('adjusted-ebitda-max', data.adjusted_ebitda_max);
    }

    Alerts.defaults = {};
    window.Alerts = Alerts;

})(jQuery);